/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DailyNavReviewActionLog = {
  readonly field?: DailyNavReviewActionLog.field;
  readonly created_by_name?: string;
  readonly created_at?: string;
};
export namespace DailyNavReviewActionLog {
  export enum field {
    REVIEWED_BY_SCALAR = 'reviewed_by_scalar',
    DISCUSSED_WITH_FUND = 'discussed_with_fund',
    PRICE_ADJUSTED = 'price_adjusted',
    PRICE_ADJUSTMENT_TIMING = 'price_adjustment_timing',
  }
}
